import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

const getOrderProcessingViews = props => {
  return (
    <LazyLoaderWrapper {...props} testId='order_processing_view' importPath='ORDER_PROCESSING_VIEW'></LazyLoaderWrapper>
  );
};

const OrderProcessingViews = props => {
  return getOrderProcessingViews(props);
};

export default OrderProcessingViews;
